var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, TemplateRef } from '@angular/core';
import { SelfService } from 'src/app/bpg-self-services/self-services.service.ts';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { BpgAdminServices } from '../../bpg-admin/bpg-admin-services';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { BpgCommonService } from 'src/app/bpg-common/services/bpg-common.service';
var UserMembershipComponent = /** @class */ (function () {
    function UserMembershipComponent(spinner, selfService, adminService, dialog, bpgCommonService) {
        this.spinner = spinner;
        this.selfService = selfService;
        this.adminService = adminService;
        this.dialog = dialog;
        this.bpgCommonService = bpgCommonService;
        this.isbrowseChapterSelected = true;
        this.ismyMembershipSelected = false;
        this.siteList = [];
        this.ergList = [];
        this.regularErgList = [];
        this.virtualErgList = [];
        this.selectedErg = [];
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.userId = this.loginData['userId'];
        this.enrolledErg = [];
        this.removeMemberships = [];
        this.userEmail = sessionStorage.getItem('emailAddressForMembership');
        this.emailAddress = '';
        this.isEmailInvalid = false;
        this.noMembershipsFound = false;
        this.emailSent = false;
        this.membershipsUpdated = false;
        this.isEmailEditable = false;
    }
    UserMembershipComponent.prototype.ngOnInit = function () {
        if (this.userEmail === "" || this.userEmail === null || this.userEmail === undefined ||
            !(this.userEmail.endsWith('@toyota.com') || this.userEmail.endsWith('@lexus.com') || this.userEmail.endsWith('@scion.com'))) {
            this.isEmailEditable = true;
        }
        this.logUserAction();
        this.getEnrolledErgs();
        this.getRegularAndVirtualErgs();
    };
    UserMembershipComponent.prototype.getRegularAndVirtualErgs = function () {
        var _this = this;
        this.spinner.show();
        this.selfService.getVirtualBpgs(this.userId).subscribe(function (data) {
            _this.spinner.hide();
            if (data != null && data !== undefined) {
                if (data['regularMemberships']) {
                    var regularMemberships = data['regularMemberships'];
                    if (regularMemberships.bpgList) {
                        _this.regularErgList = regularMemberships.bpgList;
                        _this.siteId = regularMemberships.siteId;
                        _this.siteName = regularMemberships.siteName;
                        _this.isDefaultSite = _this.siteName === 'DEFAULT SITE LOCATION';
                        if (_this.regularErgList.length > 0) {
                            _this.regularErgList.map(function (res) {
                                res.siteId = _this.siteId;
                                res.siteName = _this.siteName;
                            });
                        }
                    }
                }
                if (data['virtualMemberships']) {
                    _this.virtualErgList = data['virtualMemberships'];
                }
            }
        });
    };
    UserMembershipComponent.prototype.selectChapter = function (data) {
        this.disableButton = true;
        var bpg = JSON.parse(JSON.stringify(data));
        this.virtualErgList.map(function (res) {
            if (res.bpgId === bpg.bpgId) {
                res.checked = true;
            }
        });
        this.virtualMembershipErgIdSelected = bpg.bpgId;
        this.ergSiteList = [];
        this.ergSiteList = bpg.siteDetails;
        this.ergSiteList.forEach(function (res) {
            res.bpgId = bpg.bpgId;
            res.bpgName = bpg.bpgName;
        });
        var dialogConfig = new MatDialogConfig();
        dialogConfig.minHeight = "30vh";
        dialogConfig.maxHeight = "60vh";
        dialogConfig.width = "50vw";
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        var dialogRef = this.dialog.open(this.callAPIDialog, dialogConfig);
        dialogRef.updatePosition({
            top: '27vh'
        });
    };
    UserMembershipComponent.prototype.toggleRadio = function (data) {
        this.disableButton = false;
        this.selectedChapter = data;
    };
    UserMembershipComponent.prototype.confirmVirtualMembership = function () {
        var _this = this;
        this.selectedErg.map(function (res) {
            if (res.bpgName === _this.selectedChapter.bpgName) {
                _this.selectedErg.splice(_this.selectedErg.indexOf(res), 1);
            }
        });
        this.virtualErgList.map(function (res) {
            if (res.bpgId === _this.selectedErg.bpgId) {
                res.checked = true;
            }
        });
        this.selectedErg.push(this.selectedChapter);
        this.dialog.closeAll();
    };
    UserMembershipComponent.prototype.closePopup = function () {
        var _this = this;
        this.virtualErgList.map(function (res) {
            if (res.bpgId === _this.virtualMembershipErgIdSelected) {
                res.checked = false;
            }
        });
        this.dialog.closeAll();
    };
    UserMembershipComponent.prototype.getEnrolledErgs = function () {
        var _this = this;
        this.noMembershipsFound = false;
        this.selfService.getEnrolledBpg(this.userId).subscribe(function (data) {
            if (data != null && data !== undefined) {
                if (data.length === 0) {
                    _this.noMembershipsFound = true;
                }
                else {
                    _this.enrolledErg = data;
                    _this.enrolledErg.map(function (res) {
                        res.viewSite = true;
                        if (res.isBaseSite) {
                            _this.regularMembershipsExists = true;
                        }
                        else {
                            _this.virtualMembershipsExists = true;
                        }
                    });
                }
            }
        });
    };
    UserMembershipComponent.prototype.removeMembership = function (data, data1) {
        this.method = "onRemoveMembership";
        this.param = data;
        this.param1 = data1;
        this.msg = " Are you sure you want to cancel the membership ? ";
    };
    UserMembershipComponent.prototype.onRemoveMembership = function () {
        var _this = this;
        this.enrolledErg.map(function (sample3) {
            if (sample3.siteId === _this.param1) {
                var sample2 = sample3.bpgList.filter(function (list) { return list.bpgId === _this.param; });
                sample3 = __assign({}, sample3, { bpgList: sample2 });
                _this.removeMemberships.push(sample3);
            }
        });
        this.enrolledErg = this.enrolledErg.map(function (sample) {
            if (sample.siteId === _this.param1) {
                var sample1 = sample.bpgList.filter(function (list) { return list.bpgId !== _this.param; });
                sample = __assign({}, sample, { bpgList: sample1 });
            }
            return sample;
        });
        this.regularMembershipsExists = false;
        this.virtualMembershipsExists = false;
        this.enrolledErg.map(function (res) {
            if (res.isBaseSite && res.bpgList.length > 0) {
                _this.regularMembershipsExists = true;
            }
            if (!res.isBaseSite && res.bpgList.length > 0) {
                _this.virtualMembershipsExists = true;
            }
        });
    };
    UserMembershipComponent.prototype.showHideChapterMembership = function (data) {
        this.enrolledErg.map(function (res) {
            if (res.siteName === data) {
                res.viewSite = !res.viewSite;
            }
        });
    };
    /** to select the checkbox
   * @class BpgListComponent
   * @method toggleCheckbox
   */
    UserMembershipComponent.prototype.toggleCheckbox = function (event, data, regularOrVirtual) {
        var _this = this;
        var bpg = JSON.parse(JSON.stringify(data));
        if (event.target.checked) {
            if (regularOrVirtual === 'regular') {
                this.selectedErg.push(bpg);
                this.regularErgList.map(function (a) {
                    if (a.bpgName === bpg.bpgName) {
                        Object.assign(a, {
                            'showLeadership': true,
                            'siteId': _this.siteId,
                            'siteName': _this.siteName
                        });
                    }
                });
                this.selectedErg.map(function (res) {
                    if (bpg.bpgId === res.bpgId && res.siteId === _this.siteId) {
                        res.chair = false;
                        res.viceChair = false;
                        res.communicationChair = false;
                        res.financeChair = false;
                    }
                });
            }
            else {
                this.selectChapter(bpg);
            }
        }
        else {
            var index_1 = -1;
            this.selectedErg.map(function (res) {
                if (data.bpgId === res.bpgId) {
                    index_1 = _this.selectedErg.indexOf(res);
                }
            });
            if (index_1 !== -1) {
                this.selectedErg.splice(index_1, 1);
                if (regularOrVirtual === 'regular') {
                    this.regularErgList.map(function (a) {
                        if (a.bpgName === bpg.bpgName) {
                            Object.assign(a, {
                                'showLeadership': false,
                                'siteId': _this.siteId,
                                'siteName': _this.siteName
                            });
                        }
                    });
                    this.regularErgList.map(function (res) {
                        if (data.bpgId === res.bpgId && res.siteId === _this.siteId) {
                            res.chair = false;
                            res.viceChair = false;
                            res.communicationChair = false;
                            res.financeChair = false;
                        }
                    });
                }
                else {
                    this.virtualErgList.map(function (res) {
                        if (res.bpgId === bpg.bpgId) {
                            res.checked = false;
                        }
                    });
                }
            }
        }
    };
    /** email validation
   * @class ChapterComponent
   * @method checkEmailType
   */
    UserMembershipComponent.prototype.checkEmailType = function (event) {
        if (event.target.value !== "") {
            var re = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/);
            if (re.test(String(event.target.value).toLowerCase()) === false) {
                this.isEmailInvalid = true;
            }
            else {
                this.isEmailInvalid = false;
            }
        }
        else {
            this.isEmailInvalid = false;
        }
    };
    UserMembershipComponent.prototype.updateEmail = function () {
        var _this = this;
        this.createdDateTime = new Date();
        this.modifiedDateTime = new Date();
        var landingData = {
            "userId": this.userId,
            "personalemailId": this.emailAddress,
        };
        this.adminService.updateMembershipEmail(landingData).subscribe(function (data) {
            if (data != null && data !== undefined) {
                _this.emailSent = true;
                _this.userEmail = _this.emailAddress;
                _this.editEmailAllowed = false;
                setTimeout(function () {
                    this.emailSent = false;
                }.bind(_this), 2500);
            }
        });
    };
    UserMembershipComponent.prototype.browseChapters = function () {
        this.isbrowseChapterSelected = true;
        this.ismyMembershipSelected = false;
    };
    UserMembershipComponent.prototype.myMemberships = function () {
        this.isbrowseChapterSelected = false;
        this.ismyMembershipSelected = true;
    };
    UserMembershipComponent.prototype.selectChapterMembership = function (bpg, data, _virtualOrRegular) {
        var _this = this;
        this.selectedErg.map(function (res) {
            if (res.bpgId === bpg.bpgId && res.siteId === _this.siteId) {
                if (data === 'chair') {
                    res.chair = !res.chair;
                }
                if (data === 'viceChair') {
                    res.viceChair = !res.viceChair;
                }
                if (data === 'financeChair') {
                    res.financeChair = !res.financeChair;
                }
                if (data === 'communicationChair') {
                    res.communicationChair = !res.communicationChair;
                }
            }
        });
        this.regularErgList.map(function (res) {
            if (res.bpgId === bpg.bpgId && res.siteId === _this.siteId) {
                res.siteName = _this.siteName;
                if (data === 'chair') {
                    res.chair = !res.chair;
                }
                if (data === 'viceChair') {
                    res.viceChair = !res.viceChair;
                }
                if (data === 'financeChair') {
                    res.financeChair = !res.financeChair;
                }
                if (data === 'communicationChair') {
                    res.communicationChair = !res.communicationChair;
                }
            }
        });
    };
    UserMembershipComponent.prototype.undoRemoveMembership = function (bpg, siteId) {
        var _this = this;
        this.enrolledErg = this.enrolledErg.map(function (sample) {
            if (sample.siteId === siteId) {
                sample.bpgList.push(bpg);
            }
            return sample;
        });
        this.removeMemberships = this.removeMemberships.map(function (sample) {
            if (sample.siteId === siteId) {
                var sample1 = sample.bpgList.filter(function (list) { return list.bpgId !== bpg.bpgId; });
                sample = __assign({}, sample, { bpgList: sample1 });
            }
            return sample;
        });
        this.removeMemberships = this.removeMemberships.filter(function (res) {
            return res.bpgList.length > 0;
        });
        this.regularMembershipsExists = false;
        this.virtualMembershipsExists = false;
        this.enrolledErg.map(function (res) {
            if (res.isBaseSite && res.bpgList.length > 0) {
                _this.regularMembershipsExists = true;
            }
            if (!res.isBaseSite && res.bpgList.length > 0) {
                _this.virtualMembershipsExists = true;
            }
        });
    };
    UserMembershipComponent.prototype.editEmail = function () {
        this.editEmailAllowed = true;
        this.emailAddress = this.userEmail;
    };
    UserMembershipComponent.prototype.saveMembership = function () {
        var _this = this;
        this.spinner.show();
        var submitData = {
            userId: this.userId,
            'addMembership': this.selectedErg,
            'removeMembership': this.removeMemberships
        };
        this.selfService.saveMembership(submitData).subscribe(function (data) {
            if (data != null && data !== undefined) {
                _this.spinner.hide();
                _this.membershipsUpdated = true;
                _this.selectedErg = [];
                _this.removeMemberships = [];
                _this.getEnrolledErgs();
                _this.getRegularAndVirtualErgs();
                window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
                setTimeout(function () {
                    _this.membershipsUpdated = false;
                    _this.ismyMembershipSelected = true;
                    _this.isbrowseChapterSelected = false;
                }, 1000);
            }
        });
    };
    UserMembershipComponent.prototype.logUserAction = function () {
        var data = {
            userId: this.userId,
            categoryDescription: "Membership Application"
        };
        this.bpgCommonService.logUserAction(data).subscribe(function (_data) { });
    };
    return UserMembershipComponent;
}());
export { UserMembershipComponent };
